import {
  CarrierLevel,
  CompanyFilterType,
  IndustryLevel,
  IntermediaryLevel,
  ProductLevel,
} from 'modules/decisionsNext/api/types';

import {MarketCategory, MarketType} from 'core/constants/paths';

export const marketTypeToFilterTypeMap = {
  [MarketType.ICO]: CompanyFilterType.Carrier,
  [MarketType.BCO]: CompanyFilterType.PayTo,
  [MarketType.INTERMEDIARY]: CompanyFilterType.Intermediary,
};

export const marketCategoryToCarrierLevelMap = {
  [MarketCategory.ULTIMATE]: CarrierLevel.UltimateParentCarrier,
  [MarketCategory.PARENT]: CarrierLevel.ParentCarrier,
  [MarketCategory.CHILD]: CarrierLevel.IssuingPaper,
};

export const carrierLevelToFilterKey = {
  [CarrierLevel.UltimateParentCarrier]: 'ultimateCarrierIds',
  [CarrierLevel.ParentCarrier]: 'parentCarrierIds',
  [CarrierLevel.IssuingPaper]: 'issuingPaperIds',
} as const;

export const carrierLevelToCompanyFilterKey = {
  [CarrierLevel.UltimateParentCarrier]: 'ultimateParentIds',
  [CarrierLevel.ParentCarrier]: 'parentIds',
  [CarrierLevel.IssuingPaper]: 'childIds',
};

export const carrierLevelToIntermediaryLevel = {
  [CarrierLevel.UltimateParentCarrier]: IntermediaryLevel.UltimateParentIntermediary,
  [CarrierLevel.ParentCarrier]: IntermediaryLevel.ParentIntermediary,
  [CarrierLevel.IssuingPaper]: IntermediaryLevel.ChildIntermediary,
};

export const intermediaryLevelToCompanyFilterKey = {
  [IntermediaryLevel.UltimateParentIntermediary]: 'ultimateParentIds',
  [IntermediaryLevel.ParentIntermediary]: 'parentIds',
  [IntermediaryLevel.ChildIntermediary]: 'childIds',
};

export const intermediaryLevelToFilterKey = {
  [IntermediaryLevel.UltimateParentIntermediary]: 'ultimateIntermediaryIds',
  [IntermediaryLevel.ParentIntermediary]: 'parentIntermediaryIds',
  [IntermediaryLevel.ChildIntermediary]: 'childIntermediaryIds',
} as const;

export const industryLevelToFilterKey = {
  [IndustryLevel.Group]: 'industryGroupIds',
  [IndustryLevel.Industry]: 'industryIds',
  [IndustryLevel.SubGroup]: 'industrySubGroupIds',
} as const;

export const productLevelToFilterKey = {
  [ProductLevel.Product]: 'productIds',
  [ProductLevel.Group]: 'productGroupIds',
  [ProductLevel.InsuranceSegment]: 'productInsuranceSegmentIds',
  [ProductLevel.SuperGroup]: 'productSuperGroupIds',
} as const;
